// Equity specific actions, here we will define actions which will only be used inside the feature specific sagas
// reducers are not needed

import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ PaymentV2_ADDFUNDS ]';

const Actions = {
	initiateAddFundsPayment: `${MODULE_PREFIX} initiateAddFundsPayment`,
    fetchAddFundsPaymentLandingDetails: `${MODULE_PREFIX} fetchAddFundsPaymentLandingDetails`,
    cancelAddFundsPayment: `${MODULE_PREFIX} cancelAddFundsPayment`,
    fetchAddFundsBankDetails: `${MODULE_PREFIX} fetchAddFundsBankDetails`,
    setFirstAddFundsSuccess: `${MODULE_PREFIX} setFirstAddFundsSuccess`,
};

export const initiateAddFundsPayment = createAction(Actions.initiateAddFundsPayment);
export const fetchAddFundsPaymentLandingDetails = createAction(Actions.fetchAddFundsPaymentLandingDetails);
export const cancelAddFundsPayment = createAction(Actions.cancelAddFundsPayment);
export const fetchAddFundsBankDetails = createAction(Actions.fetchAddFundsBankDetails);
export const setFirstAddFundsSuccess = createAction(Actions.setFirstAddFundsSuccess);

const initialState = {
	firstAddFundsSuccessfull: false,
};

export const getFirstAddFundsSuccessfull = (state) => {
    const firstAddFundsSuccessfull = get(state, 'addFundsPayment.firstAddFundsSuccessfull', false);
    return firstAddFundsSuccessfull;
}

export default createReducer(initialState, (builder) => {
	builder.addCase(setFirstAddFundsSuccess, (state, action) => {
		state.firstAddFundsSuccessfull = action.payload;
	});
});

